/**
 *  @class
 *  @function FacetsToggle
 */
class FacetsToggle {

  constructor() {
    this.container = document.getElementById('Facet-Drawer');
    let button = document.getElementById('Facets-Toggle');

    // Add functionality to buttons
    if (button) {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        
        // Store the element that opened the drawer for focus return
        this.previouslyFocusedElement = document.activeElement;
        
        document.getElementsByTagName('body')[0].classList.toggle('open-cc');
        this.container.classList.toggle('active');
        
        // If drawer is now active, focus on it and setup focus trap
        if (this.container.classList.contains('active')) {
          setTimeout(() => {
            this.container.focus();
            this.setupFocusTrap(this.container);
          }, 100);
        }
      });
    }
    setTimeout(function () {
      window.dispatchEvent(new Event('resize.resize-select'));
    }, 10);
  }

  setupFocusTrap(container) {
    const focusableElements = container.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    
    if (focusableElements.length === 0) return;
    
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];
    
    // Handle Tab key to trap focus
    const handleKeyDown = (e) => {
      if (e.key === 'Tab') {
        if (e.shiftKey) {
          // Shift + Tab
          if (document.activeElement === firstFocusableElement) {
            e.preventDefault();
            lastFocusableElement.focus();
          }
        } else {
          // Tab
          if (document.activeElement === lastFocusableElement) {
            e.preventDefault();
            firstFocusableElement.focus();
          }
        }
      } else if (e.key === 'Escape') {
        // Close drawer on escape
        this.closeDrawer();
      }
    };
    
    // Store the handler for cleanup
    container._focusTrapHandler = handleKeyDown;
    container.addEventListener('keydown', handleKeyDown);
  }

  closeDrawer() {
    document.getElementsByTagName('body')[0].classList.remove('open-cc');
    this.container.classList.remove('active');
    
    // Return focus to the element that opened the drawer
    if (this.previouslyFocusedElement && this.previouslyFocusedElement.focus) {
      this.previouslyFocusedElement.focus();
    }
    
    // Clean up focus trap
    if (this.container._focusTrapHandler) {
      this.container.removeEventListener('keydown', this.container._focusTrapHandler);
      delete this.container._focusTrapHandler;
    }
  }
}


class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const container = document.getElementsByClassName('thb-filter-count');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    for (var item of container) {
      item.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html,
          url
        }];
        FacetFiltersForm.renderFilters(html);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);

        window.facetsToggleInstance = new FacetsToggle();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);

    new FacetsToggle();
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

    let top = document.getElementById('ProductGridContainer').getBoundingClientRect().top + document.documentElement.scrollTop - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) - 30;

    window.scrollTo({
      top: top,
      left: 0,
      behavior: "smooth"
    });
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementsByClassName('thb-filter-count');

    if (countHtml) {
      for (var item of container) {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove('loading');
      }
    }

  }

  static renderFilters(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    // Swap in each form's filters as the server rendered them. Rows can't be
    // matched by position: Shopify drops filters that have no values in the
    // current results, so the list changes length as filters are applied.
    ['#FacetFiltersForm', '#FacetFiltersFormMobile'].forEach((selector) => {
      const form = document.querySelector(selector);
      const parsedForm = parsedHTML.querySelector(selector);
      if (!form || !parsedForm) return;

      const oldRows = Array.from(form.querySelectorAll('collapsible-row'));
      const newRows = Array.from(parsedForm.querySelectorAll('collapsible-row'));
      if (!oldRows.length) {
        form.innerHTML = parsedForm.innerHTML;
        return;
      }

      // Leave a row alone while the user is typing in it (the price boxes):
      // replacing it would drop their focus and the keystrokes after it
      const focused = document.activeElement;
      const typingRow = focused && focused.matches('input[type="text"]') && form.contains(focused)
        ? focused.closest('collapsible-row')
        : null;
      const keepAt = typingRow ? newRows.findIndex(row => row.dataset.filter === typingRow.dataset.filter) : -1;

      if (keepAt === -1) {
        FacetFiltersForm.swapRows(oldRows, newRows);
      } else {
        const typingAt = oldRows.indexOf(typingRow);
        FacetFiltersForm.swapRows(oldRows.slice(0, typingAt), newRows.slice(0, keepAt), row => typingRow.before(row));
        FacetFiltersForm.swapRows(oldRows.slice(typingAt + 1), newRows.slice(keepAt + 1), row => typingRow.after(row));
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    new FacetsToggle();
  }

  // Swap old rows for new ones in place, one for one, then add or drop the
  // extras. Inserting the whole list at once trips the browser's scroll
  // anchoring and jumps the drawer.
  static swapRows(oldRows, newRows, insertFirst) {
    newRows.forEach((row, i) => {
      if (oldRows[i]) oldRows[i].replaceWith(row);
      else if (i > 0) newRows[i - 1].after(row);
      else insertFirst(row);
    });
    oldRows.slice(newRows.length).forEach(row => row.remove());
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-filter-count'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

  }

  static updateURLHash(searchParams) {
    history.pushState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData);
    if (searchParams.get('filter.v.price.gte') === "0.00") {
      searchParams.delete('filter.v.price.gte');
    }
    if (document.querySelector('.price_slider')) {
      if (searchParams.get('filter.v.price.lte') === parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2)) {
        searchParams.delete('filter.v.price.lte');
      }
    }
    FacetFiltersForm.renderPage(searchParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();


class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define('facet-remove', FacetRemove);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {

  constructor() {
    super();
  }
  connectedCallback() {
    let slider = this.querySelector('.price_slider'),
      amounts = this.querySelector('.price_slider_amount'),
      args = {
        start: [parseFloat(slider.dataset.minValue || 0), parseFloat(slider.dataset.maxValue || slider.dataset.max)],
        connect: true,
        step: 10,
        direction: document.dir,
        range: {
          'min': 0,
          'max': parseFloat(slider.dataset.max)
        }
      },
      event = new CustomEvent('input'),
      form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');

    if (slider.classList.contains('noUi-target')) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    slider.noUiSlider.on('update', function (values) {
      amounts.querySelector('.field__input_min').value = values[0];
      amounts.querySelector('.field__input_max').value = values[1];
    });
    slider.noUiSlider.on('change', function (values) {
      form.querySelector('form').dispatchEvent(event);
    });
  }
}
customElements.define('price-slider', PriceSlider);

window.addEventListener('load', () => {
  window.facetsToggleInstance = new FacetsToggle();
});

/**
 * Lock background page scrolling while the mobile filters drawer is open.
 * `overflow: hidden` on <body> is unreliable on iOS Safari, so we fix the body
 * in place and restore the scroll position when the drawer closes. Driven by a
 * MutationObserver so every open/close path (toggle, close button, click-capture,
 * apply, Escape) is covered from a single source of truth.
 */
(function () {
  const drawer = document.getElementById('Facet-Drawer');
  if (!drawer) return;

  let lockedScrollY = 0;

  const lockScroll = () => {
    if (document.body.classList.contains('filters-scroll-locked')) return;
    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.top = `-${lockedScrollY}px`;
    document.body.classList.add('filters-scroll-locked');
  };

  const unlockScroll = () => {
    if (!document.body.classList.contains('filters-scroll-locked')) return;
    document.body.classList.remove('filters-scroll-locked');
    document.body.style.top = '';
    window.scrollTo(0, lockedScrollY);
  };

  const sync = () => {
    // Only lock on mobile/tablet, where the drawer overlays the full page.
    if (drawer.classList.contains('active') && window.innerWidth < 1068) {
      lockScroll();
    } else {
      unlockScroll();
    }
  };

  new MutationObserver(sync).observe(drawer, {
    attributes: true,
    attributeFilter: ['class'],
  });

  // Release the lock if the viewport grows past the mobile breakpoint.
  window.addEventListener('resize', sync);
})();